import { InteractionEvents } from "./InteractionEvents";
import { ButtonAnimator } from "./ButtonAnimator";
import { Button } from "./Button";

/**
 */
export class ButtonTextureStates extends ButtonAnimator {
  /**
   */
  private textureOut: PIXI.Texture;
  private textureOver: PIXI.Texture;
  private textureDown: PIXI.Texture;

  /**
   * @param out
   * @param over
   * @param down
   */
  constructor(out: PIXI.Texture, over: PIXI.Texture, down: PIXI.Texture) {
    super();
    this.textureOut = out;
    this.textureOver = over;
    this.textureDown = down;
  }

  /**
   * @param target
   */
  public init(target: Button) {
    super.init(target);
    if (!PIXI.utils.isMobile.any) {
      target.on(InteractionEvents.MouseOver, this.over, this);
      target.on(InteractionEvents.MouseDown, this.down, this);
      target.on(InteractionEvents.MouseOut, this.out, this);
      target.on(InteractionEvents.MouseUp, this.up, this);
      target.on(InteractionEvents.MouseUpOutside, this.down, this);
    }
    target.on(InteractionEvents.TouchStart, this.down, this);
    target.on(InteractionEvents.TouchEnd, this.up, this);
    target.on(InteractionEvents.TouchEndOutside, this.up, this);
  }

  /**
   * Called on animation start. Override this and do your async
   * animation and then call resolve.
   *
   * @param target - Target Container.
   * @param resolve - Resolve callback.
   */
  public play(target: PIXI.Container, resolve: Function) {
    resolve();
  }

  public down(e: PIXI.interaction.InteractionEvent) {
    this.target.texture = this.textureDown;
  }

  public up(e: PIXI.interaction.InteractionEvent) {
    this.target.texture = this.textureOut;
  }

  public over(e: PIXI.interaction.InteractionEvent) {
    this.target.texture = this.textureOver;
  }

  public out(e: PIXI.interaction.InteractionEvent) {
    this.target.texture = this.textureOut;
  }
}
